<div [hidden]="loading" lang="{{lang}}">
  <router-outlet></router-outlet>
</div>
<app-message></app-message>